export default __webpack_public_path__ + "static/media/sterilization-room.c381a511.jpg";